import React from 'react';
import subscriptionUtils from '../subscriptionUtils';
import {privilegeUtils} from '../privilegeUtils';
import smbUtils from '../smbUtils';
import reportUtils from '../reportUtils';
import {multipleSubscriptionsUtils} from '../solutionUtils';

export default (t, isUpgrade, functionType, accountSummary) => {
  const {
    canManageSku,
    canManageRecommend,
    canManageStore,
    canManageLicense,
    canManageModules,
  } = privilegeUtils;

  const isCnSite = smbUtils.isCnSite(accountSummary);
  const isSkinAnalysis = privilegeUtils.isSkinAnalysis(accountSummary);
  const isSimulation = privilegeUtils.isSimulation(accountSummary);
  const isSkincareAboveV2 = subscriptionUtils.isSkincareVersionAbove2(
    accountSummary
  );
  const showAnalysisDetection = reportUtils.showSkinAnalysisAnalytics(
    accountSummary
  );
  const showSimulationDetection = reportUtils.showSimulationAnalytics(
    accountSummary
  );
  const showClientOverview =
    isSkincareAboveV2 &&
    !isCnSite &&
    (showAnalysisDetection || showSimulationDetection);

  const getUiConfigurationPages = () => {
    const version = subscriptionUtils.getSkincareVersion(accountSummary);
    const pages = [
      {
        id: 1220,
        title: t('c.l.sidebar.1171.title', 'Overview'),
        link: '/skincare-pro/ui-configuration/overview',
        show: true,
      },
      {
        id: 1250,
        title: t('p.s.uiconfiguration.tabs.common.settings', 'Common Settings'),
        link: '/skincare-pro/ui-configuration/common-settings',
        show: true,
      },
      {
        id: 4000,
        title: t('c.l.sidebar.4000.title', 'Name Preferences'),
        link: '/skincare-pro/ui-configuration/name-preferences',
        show: (subscriptionUtils.getSkincareVersion(accountSummary) >= 2 && isSkinAnalysis) ||
              (subscriptionUtils.isSkincareVersionAbove2AndHd(accountSummary) && isSimulation),
      },
      {
        id: 1260,
        title: t('c.l.sidebar.1200.title', 'Landing Page'),
        link: '/skincare-pro/ui-configuration/landing',
        show: true,
      },
      {
        id: 1200,
        title: t('p.s.c.customization.user.consent', 'User Consent'),
        link: '/skincare-pro/ui-configuration/user-consent',
        show: true,
      },
      {
        id: 1300,
        title: t('c.l.sidebar.1150.skincarepro.title', 'Survey Form'),
        link: '/skincare-pro/ui-configuration/survey-form',
        show: true,
      },
      {
        id: 1210,
        title: t('c.l.sidebar.1210.title', 'Skincare Detection'),
        link: '/skincare-pro/ui-configuration/skincare-detection',
        show: isSkinAnalysis,
      },
      {
        id: 1270,
        title: t(
          'p.s.uiconfiguration.skinresultpage.skingetresult.title',
          'Skin Result Page & Get Skin Result Page'
        ),
        link: '/skincare-pro/ui-configuration/skin-result',
        show: isSkinAnalysis,
      },
      {
        id: 1230,
        title: t(
          'p.s.uiconfiguration.sharedskinresultpage.title',
          'Shared Skin Result Page'
        ),
        link: '/skincare-pro/ui-configuration/shared-skin-result-page',
        show: isSkinAnalysis,
      },
      {
        id: 1280,
        title: t('p.s.uiconfiguration.simulation.page', 'Simulation Page'),
        link: '/skincare-pro/ui-configuration/simulation-page',
        show: isCnSite ? false : isSimulation,
      },
      {
        id: 1280,
        title: t(
          'p.s.uiconfiguration.face.assessment.page',
          'Face Assessment Page'
        ),
        link: '/skincare-pro/ui-configuration/face-assessment',
        show: isCnSite ? false : isSimulation,
      },
      {
        id: 1290,
        title: t(
          'p.s.uiconfiguration.simulationresultpage.getsimulationresult.title',
          'Simulation Report Page & Get Simulation Report Page'
        ),
        link: '/skincare-pro/ui-configuration/simulation-report',
        show: isCnSite ? false : isSimulation,
      },
      {
        id: 1240,
        title: t(
          'p.s.uiconfiguration.sharedsimulationreportpage.title',
          'Shared Simulation Report Page'
        ),
        link: '/skincare-pro/ui-configuration/shared-simulation-report-page',
        show: isSimulation,
      },
    ];
    return version === 1
      ? [
          {
            id: 1200,
            title: t('c.l.sidebar.1200.title', 'Landing Page'),
            link: '/skincare-pro/ui-configuration/landing-page',
          },
          {
            id: 1210,
            title: t('c.l.sidebar.1210.title', 'Skincare Detection'),
            link: '/skincare-pro/ui-configuration/skincare-detection',
          },
          {
            id: 1220,
            title: t('c.l.sidebar.1220.title', 'Skin Result Page'),
            link: '/skincare-pro/ui-configuration/skin-result-page',
          },
          {
            id: 1230,
            title: t('c.l.sidebar.1230.title', 'Get Skin Result'),
            link: '/skincare-pro/ui-configuration/get-skin-result',
          },
        ]
      : pages.filter(page => page.show);
  };

  return [
    {
      id: 1000,
      title: t('c.l.sidebar.1000.title', 'SERVICES'),
      items: [
        {
          id: 1010,
          title: t('c.l.sidebar.1010.title', 'Home'),
          link: '/',
          icon: 'la la-home',
          sublinks: ['/', '/home/start-guide'],
        },
        functionType === 'MAKEUP' && {
          id: 1100,
          privileges:
            'P103_SKU_LOOK_MNGT,P101_WM_SETTINGS,P104_API_INTEGRATION',
          title: t('c.l.sidebar.1100.makeup.title', 'Makeup'),
          link: canManageSku(accountSummary)
            ? '/products/list-skus'
            : canManageModules(accountSummary)
            ? '/web-module/configuration'
            : isUpgrade
            ? '/web-module/api-integration'
            : '/web-module/api-document',
          icon: 'la la-globe',
          sublinks: [
            '/products/add-sku',
            '/products/edit-sku',
            '/products/view-sku',
            '/products/list-looks',
            '/products/add-look',
            '/products/edit-look',
            '/products/view-look',
            '/products/list-products',
            '/products/add-product',
            '/products/edit-product',
            '/products/view-product',
            '/web-module/configuration',
            '/web-module/api-document',
            '/web-module/api-integration',
          ],
          items: [
            {
              id: 1110,
              privileges: 'P103_SKU_LOOK_MNGT',
              title: isUpgrade
                ? t('c.l.sidebar.1110.upgrade.title', 'SKU/Makeup Products')
                : t('c.l.sidebar.1110.title', 'SKUs'),
              className: 'tutorial-sku-creation',
              link: '/products/list-skus',
              sublinks: [
                '/products/add-sku',
                '/products/edit-sku',
                '/products/view-sku',
                '/products/list-looks',
                '/products/add-look',
                '/products/edit-look',
                '/products/view-look',
                '/products/list-products',
                '/products/add-product',
                '/products/edit-product',
                '/products/view-product',
              ],
              // newIcon: true,
            },
            {
              id: 1130,
              privileges: 'P101_WM_SETTINGS',
              title: t('c.l.sidebar.1130.title', 'Module Configuration'),
              link: '/web-module/configuration',
            },
            {
              id: 1150,
              privileges: 'P104_API_INTEGRATION',
              title: t('c.l.sidebar.1150.title', 'API Integration'),
              link: isUpgrade
                ? '/web-module/api-integration'
                : '/web-module/api-document',
              // newIcon: true,
              items: [
                {
                  id: 1180,
                  title: t('c.l.sidebar.1180.title', 'Try-on Widget'),
                  link: '/web-module/api-integration',
                  shouldUpgrade: !isUpgrade,
                },
                {
                  id: 1190,
                  title: t('c.l.sidebar.1190.title', 'Embedded iframe'),
                  link: '/web-module/api-document',
                },
                {
                  id: 1240,
                  title: t('c.l.sidebar.1240.title', 'Platforms'),
                  link: '/web-module/platforms',
                },
              ],
              sublinks: [
                '/web-module/api-integration',
                '/web-module/api-document',
                '/web-module/platforms',
              ],
            },
          ],
        },
        functionType === 'EYEWEAR' && {
          id: 1100,
          privileges:
            'P103_SKU_LOOK_MNGT,P101_WM_SETTINGS,P104_API_INTEGRATION',
          title: t('c.l.sidebar.1100.eyewear.title', 'Eyewear'),
          link: canManageSku(accountSummary)
            ? '/eyewear/list-products'
            : canManageModules(accountSummary)
            ? '/web-module/configuration'
            : isUpgrade
            ? '/web-module/api-integration'
            : '/web-module/api-document',
          icon: 'la la-globe',
          sublinks: [
            '/web-module/configuration',
            '/web-module/api-document',
            '/web-module/api-integration',
            '/eyewear/list-frame',
            '/eyewear/add-frame',
            '/eyewear/edit-frame',
            '/eyewear/list-products',
            '/eyewear/add-product',
            '/eyewear/edit-product',
            '/eyewear/add-product-from-library',
            '/eyewear/list-category',
            '/eyewear/list-lens',
          ],
          items: [
            {
              id: 1110,
              privileges: 'P103_SKU_LOOK_MNGT',
              title: isUpgrade
                ? t('c.l.sidebar.1110.frame.title', 'Frame/Eyewear Products')
                : t('c.l.sidebar.1110.title', 'SKUs'),
              className: 'tutorial-sku-creation',
              link: '/eyewear/list-products',
              sublinks: [
                '/eyewear/list-frame',
                '/eyewear/add-frame',
                '/eyewear/edit-frame',
                '/eyewear/list-products',
                '/eyewear/add-product',
                '/eyewear/edit-product',
                '/eyewear/add-product-from-library',
                '/eyewear/list-category',
                '/eyewear/list-lens',
              ],
              // newIcon: true,
            },
            {
              id: 1130,
              privileges: 'P101_WM_SETTINGS',
              title: t('c.l.sidebar.1130.title', 'Module Configuration'),
              link: '/web-module/configuration',
            },
            {
              id: 1150,
              privileges: 'P104_API_INTEGRATION',
              title: t('c.l.sidebar.1150.title', 'API Integration'),
              link: isUpgrade
                ? '/web-module/api-integration'
                : '/web-module/api-document',
              // newIcon: true,
              items: [
                {
                  id: 1180,
                  title: t('c.l.sidebar.1180.title', 'Try-on Widget'),
                  link: '/web-module/api-integration',
                  shouldUpgrade: !isUpgrade,
                },
                {
                  id: 1190,
                  title: t('c.l.sidebar.1190.title', 'Embedded iframe'),
                  link: '/web-module/api-document',
                },
              ],
              sublinks: [
                '/web-module/api-integration',
                '/web-module/api-document',
                '/web-module/platforms',
              ],
            },
          ],
        },
        functionType === 'SKINCARE_PRO' && {
          id: 1200,
          privileges:
            'P103_SKU_LOOK_MNGT,P108_RECOMMENDATION_RULE,P105_UI_CONFIGURATION',
          title: t('c.l.sidebar.1100.skincarepro.title', 'Skincare Pro'),
          link: isSkinAnalysis
            ? canManageSku(accountSummary)
              ? '/skincare-pro/add-skincare/skincare-product'
              : canManageRecommend(accountSummary)
              ? '/skincare-pro/recommendation-rule'
              : '/skincare-pro/ui-configuration/overview'
            : '/skincare-pro/ui-configuration/overview',
          icon: 'la la-globe',
          sublinks: [
            '/skincare-pro/ui-configuration',
            '/skincare-pro/ui-configuration/overview',
            '/skincare-pro/ui-configuration/landing-page',
            '/skincare-pro/ui-configuration/skincare-detection',
            '/skincare-pro/ui-configuration/skin-result-page',
            '/skincare-pro/ui-configuration/landing',
            '/skincare-pro/ui-configuration/skin-result',
            '/skincare-pro/ui-configuration/common-settings',
            '/skincare-pro/ui-configuration/name-preferences',
            '/skincare-pro/ui-configuration/simulation-page',
            '/skincare-pro/ui-configuration/face-assessment',
            '/skincare-pro/ui-configuration/simulation-report',
            '/skincare-pro/recommendation-rule',
            '/skincare-pro/add-skincare/skincare-product',
            '/skincare-pro/add-skincare/add-skincare-product',
            '/skincare-pro/add-skincare/edit-skincare-product',
            '/skincare-pro/add-skincare/list-product-category',
            '/skincare-pro/add-skincare/skincare-routine',
            '/skincare-pro/add-skincare/add-skincare-routine',
            '/skincare-pro/add-skincare/edit-skincare-routine',
            '/skincare-pro/add-skincare/skincare-treatment',
            '/skincare-pro/add-skincare/add-skincare-treatment',
            '/skincare-pro/add-skincare/edit-skincare-treatment',
            '/skincare-pro/add-skincare/list-treatment-category',
          ],
          items: [
            {
              id: 1130,
              privileges: 'P103_SKU_LOOK_MNGT',
              title: t('c.l.sidebar.1130.skincarepro.title', 'Products'),
              link: '/skincare-pro/add-skincare',
              sublinks: [
                '/skincare-pro/add-skincare/skincare-product',
                '/skincare-pro/add-skincare/add-skincare-product',
                '/skincare-pro/add-skincare/edit-skincare-product',
                '/skincare-pro/add-skincare/list-product-category',
                '/skincare-pro/add-skincare/skincare-routine',
                '/skincare-pro/add-skincare/add-skincare-routine',
                '/skincare-pro/add-skincare/edit-skincare-routine',
                '/skincare-pro/add-skincare/skincare-treatment',
                '/skincare-pro/add-skincare/add-skincare-treatment',
                '/skincare-pro/add-skincare/edit-skincare-treatment',
                '/skincare-pro/add-skincare/list-treatment-category',
              ],
              items: [
                {
                  id: 1300,
                  title: t('c.l.sidebar.1300.title', 'Skincare Product'),
                  link: '/skincare-pro/add-skincare/skincare-product',
                  sublinks: [
                    '/skincare-pro/add-skincare/skincare-product',
                    '/skincare-pro/add-skincare/add-skincare-product',
                    '/skincare-pro/add-skincare/edit-skincare-product',
                    '/skincare-pro/add-skincare/list-product-category',
                  ],
                },
                {
                  id: 1310,
                  title: t('c.l.sidebar.1310.title', 'Skincare Routine'),
                  link: '/skincare-pro/add-skincare/skincare-routine',
                  sublinks: [
                    '/skincare-pro/add-skincare/skincare-routine',
                    '/skincare-pro/add-skincare/add-skincare-routine',
                    '/skincare-pro/add-skincare/edit-skincare-routine',
                  ],
                },
                {
                  id: 1320,
                  title: t('c.l.sidebar.1320.title', 'Skincare Treatment'),
                  link: '/skincare-pro/add-skincare/skincare-treatment',
                  sublinks: [
                    '/skincare-pro/add-skincare/skincare-treatment',
                    '/skincare-pro/add-skincare/add-skincare-treatment',
                    '/skincare-pro/add-skincare/edit-skincare-treatment',
                    '/skincare-pro/add-skincare/list-treatment-category',
                  ],
                },
              ],
            },
            {
              id: 1140,
              privileges: 'P108_RECOMMENDATION_RULE',
              title: t(
                'c.l.sidebar.1140.skincarepro.title',
                'Recommendation Rule'
              ),
              link: '/skincare-pro/recommendation-rule',
              sublinks: ['/skincare-pro/recommendation-rule'],
            },
            ...(functionType === 'SKINCARE_PRO' &&
            subscriptionUtils.getSkincareVersion(accountSummary) >= 2
              ? [
                  {
                    id: 1150,
                    privileges: 'P110_SURVEY_FORM',
                    title: t(
                      'c.l.sidebar.1150.skincarepro.title',
                      'Survey Form'
                    ),
                    link: '/skincare-pro/survey-form',
                    sublinks: ['/skincare-pro/survey-form'],
                  },
                  {
                    id: 1160,
                    privileges: 'P109_CUSTOMIZE_EMAIL',
                    title: t('c.l.sidebar.1160.skincarepro.title', 'Email'),
                    link: '/skincare-pro/email-customization',
                    sublinks: ['/skincare-pro/email-customization'],
                  },
                ]
              : []),
            {
              id: 1120,
              privileges: 'P105_UI_CONFIGURATION',
              title: t('c.l.sidebar.1110.skincare.title', 'UI Configuration'),
              link: subscriptionUtils.isSkincareVersionAbove2(accountSummary)
                ? '/skincare-pro/ui-configuration/overview'
                : '/skincare-pro/ui-configuration/landing-page',
              items: getUiConfigurationPages(),
              sublinks: [
                '/skincare-pro/ui-configuration',
                '/skincare-pro/ui-configuration/overview',
                '/skincare-pro/ui-configuration/landing-page',
                '/skincare-pro/ui-configuration/skincare-detection',
                '/skincare-pro/ui-configuration/skin-result-page',
                '/skincare-pro/ui-configuration/get-skin-result',
                '/skincare-pro/ui-configuration/landing',
                '/skincare-pro/ui-configuration/skin-result',
                '/skincare-pro/ui-configuration/common-settings',
                '/skincare-pro/ui-configuration/simulation-page',
                '/skincare-pro/ui-configuration/face-assessment',
                '/skincare-pro/ui-configuration/simulation-report',
              ],
              // newIcon: true,
            },
          ],
        },
      ],
    },
    functionType === 'SKINCARE_PRO' &&
      subscriptionUtils.isSkincareVersionAbove2(accountSummary) &&
      !isCnSite && {
        id: 7000,
        privileges: 'P402_CRM_CUSTOMER_MNGT',
        title: t('c.l.sidebar.7000.title', 'Client'),
        items: [
          {
            id: 7100,
            privileges: 'P402_CRM_CUSTOMER_MNGT',
            title: t('c.l.sidebar.7000.title', 'Client'),
            link: '/client',
            icon: 'la la-user',
            sublinks: ['/client/client-list', '/client/client-profile'],
            items: [
              {
                id: 7110,
                privileges: 'P402_CRM_CUSTOMER_MNGT',
                title: t('c.l.sidebar.7110.title', 'Client List'),
                link: '/client/client-list',
                sublinks: ['/client/client-list'],
              },
            ],
          },
        ],
      },
    {
      id: 10000,
      title: t('c.l.sidebar.1170.title', 'Analytics'),
      privileges: 'P102_WM_REPORT',
      items: [
        {
          id: 10100,
          privileges: 'P102_WM_REPORT',
          title: t('c.l.sidebar.1170.title', 'Analytics'),
          link: '/web-module/reports',
          icon: 'la la-pie-chart',
          sublinks: (() => {
            switch (functionType) {
              case 'MAKEUP':
                return [
                  '/web-module/reports',
                  '/web-module/reports/overview',
                  '/web-module/reports/impressions',
                  '/web-module/reports/sessions',
                  '/web-module/reports/user-engagement',
                  '/web-module/reports/sku-preferences',
                ];
              case 'EYEWEAR':
                const defaultLink = [
                  '/web-module/reports',
                  '/web-module/reports/overview',
                  '/web-module/reports/impressions',
                  '/web-module/reports/sessions',
                  '/web-module/reports/user-engagement',
                  '/web-module/reports/sku-preferences',
                ];
                if (subscriptionUtils.isUniqueUsersVersion(accountSummary)) {
                  return defaultLink.concat([
                    '/web-module/reports/unique-users',
                  ]);
                }
                return defaultLink;
              case 'SKINCARE_PRO':
                if (
                  subscriptionUtils.isSkincareVersionAbove2(accountSummary) &&
                  !isCnSite
                ) {
                  return [
                    '/web-module/reports',
                    '/web-module/reports/overview',
                    '/web-module/reports/detections',
                    '/web-module/reports/client',
                    '/web-module/reports/demographics',
                    '/web-module/reports/scores',
                  ];
                }
                return [
                  '/web-module/reports',
                  '/web-module/reports/overview',
                  '/web-module/reports/detections',
                ];
              default:
                return [];
            }
          })(),
          items: [
            {
              id: 10110,
              privileges: 'P102_WM_REPORT',
              title: t('c.l.sidebar.10110.title', 'Data Analytics'),
              link: '/web-module/reports',
              icon: 'la la-pie-chart',
              sublinks: (() => {
                switch (functionType) {
                  case 'MAKEUP':
                    return [
                      '/web-module/reports',
                      '/web-module/reports/overview',
                      '/web-module/reports/impressions',
                      '/web-module/reports/sessions',
                      '/web-module/reports/user-engagement',
                      '/web-module/reports/sku-preferences',
                    ];
                  case 'EYEWEAR':
                    const defaultLink = [
                      '/web-module/reports',
                      '/web-module/reports/overview',
                      '/web-module/reports/impressions',
                      '/web-module/reports/sessions',
                      '/web-module/reports/user-engagement',
                      '/web-module/reports/sku-preferences',
                    ];
                    if (
                      subscriptionUtils.isUniqueUsersVersion(accountSummary)
                    ) {
                      return defaultLink.concat([
                        '/web-module/reports/unique-users',
                      ]);
                    }
                    return defaultLink;
                  case 'SKINCARE_PRO':
                    let defaultScpLink = [
                      '/web-module/reports',
                      '/web-module/reports/overview',
                    ];

                    if (showAnalysisDetection) {
                      defaultScpLink.push('/web-module/reports/detections');
                      defaultScpLink.push('/web-module/reports/scores');
                    }
                    if (showSimulationDetection) {
                      defaultScpLink.push('/web-module/reports/simulations');
                    }
                    if (showClientOverview) {
                      defaultScpLink = defaultScpLink.concat([
                        '/web-module/reports/client',
                        '/web-module/reports/demographics',
                      ]);
                    }
                    return defaultScpLink;
                  default:
                    return [];
                }
              })(),
              items: (() => {
                switch (functionType) {
                  case 'MAKEUP':
                    return [
                      {
                        id: 1171,
                        title: t('c.l.sidebar.1171.title', 'Overview'),
                        link: '/web-module/reports/overview',
                      },
                      {
                        id: 1173,
                        title: t('c.l.sidebar.1173.title', 'Impressions'),
                        link: '/web-module/reports/impressions',
                      },
                      {
                        id: 1175,
                        title: t('c.l.sidebar.1175.title', 'Sessions'),
                        link: '/web-module/reports/sessions',
                      },
                      {
                        id: 1177,
                        title: t('c.l.sidebar.1177.title', 'User Engagement'),
                        link: '/web-module/reports/user-engagement',
                      },
                      {
                        id: 1179,
                        title: t('c.l.sidebar.1179.title', 'SKU Preferences'),
                        link: '/web-module/reports/sku-preferences',
                      },
                    ];
                  case 'EYEWEAR':
                    if (
                      subscriptionUtils.isUniqueUsersVersion(accountSummary)
                    ) {
                      return [
                        {
                          id: 1171,
                          title: t('c.l.sidebar.1171.title', 'Overview'),
                          link: '/web-module/reports/overview',
                        },
                        {
                          id: 1187,
                          title: t('c.l.sidebar.1187.title', 'Unique Users'),
                          link: '/web-module/reports/unique-users',
                        },
                        {
                          id: 1173,
                          title: t('c.l.sidebar.1173.title', 'Impressions'),
                          link: '/web-module/reports/impressions',
                        },
                        {
                          id: 1175,
                          title: t('c.l.sidebar.1175.title', 'Sessions'),
                          link: '/web-module/reports/sessions',
                        },
                        {
                          id: 1177,
                          title: t('c.l.sidebar.1177.title', 'User Engagement'),
                          link: '/web-module/reports/user-engagement',
                        },
                        {
                          id: 1179,
                          title: t(
                            'c.l.sidebar.1179.title.eyewear',
                            'Frame Preferences'
                          ),
                          link: '/web-module/reports/sku-preferences',
                        },
                      ];
                    }
                    return [
                      {
                        id: 1171,
                        title: t('c.l.sidebar.1171.title', 'Overview'),
                        link: '/web-module/reports/overview',
                      },
                      {
                        id: 1173,
                        title: t('c.l.sidebar.1173.title', 'Impressions'),
                        link: '/web-module/reports/impressions',
                      },
                      {
                        id: 1175,
                        title: t('c.l.sidebar.1175.title', 'Sessions'),
                        link: '/web-module/reports/sessions',
                      },
                      {
                        id: 1177,
                        title: t('c.l.sidebar.1177.title', 'User Engagement'),
                        link: '/web-module/reports/user-engagement',
                      },
                      {
                        id: 1179,
                        title: t(
                          'c.l.sidebar.1179.title.eyewear',
                          'Frame Preferences'
                        ),
                        link: '/web-module/reports/sku-preferences',
                      },
                    ];
                  case 'SKINCARE_PRO':
                    let defaultScpItems = [
                      {
                        id: 1171,
                        title: t('c.l.sidebar.1171.title', 'Overview'),
                        link: '/web-module/reports/overview',
                      },
                    ];

                    if (showAnalysisDetection) {
                      defaultScpItems.push({
                        id: 1184,
                        title: t('c.l.sidebar.1184.title', 'Detections'),
                        link: '/web-module/reports/detections',
                      });
                    }
                    if (showSimulationDetection) {
                      defaultScpItems.push({
                        id: 1184,
                        title: t('c.l.sidebar.1189.title', 'Simulations'),
                        link: '/web-module/reports/simulations',
                      });
                    }
                    if (showClientOverview) {
                      defaultScpItems = defaultScpItems.concat([
                        {
                          id: 1185,
                          title: t('c.l.sidebar.1185.title', 'Client'),
                          link: '/web-module/reports/client',
                        },
                        {
                          id: 1186,
                          title: t('c.l.sidebar.1186.title', 'Demographics'),
                          link: '/web-module/reports/demographics',
                        },
                      ]);
                    }
                    if (showAnalysisDetection) {
                      defaultScpItems.push({
                        id: 1187,
                        title: t('c.l.sidebar.1188.title', 'Scores'),
                        link: '/web-module/reports/scores',
                      });
                    }

                    return defaultScpItems;
                  default:
                    return [];
                }
              })(),
            },
          ],
        },
      ],
    },
    {
      id: 8000,
      title: t('c.l.sidebar.8000.title', 'SYSTEM'),
      privileges: 'P201_SUBS_BILLING,P107_ADD_ON',
      items: [
        {
          id: 8100,
          title: t('c.l.sidebar.8100.title', 'Plan & Pricing'),
          privileges: 'P201_SUBS_BILLING',
          link: '/plan-pricing',
          icon: 'la la-tag',
          sublinks: [
            '/plan-pricing/subscription',
            '/plan-pricing/change-plan',
            '/plan-pricing/add-on-package ',
          ],
          items: [
            {
              id: 8120,
              title: t('c.l.sidebar.8120.title', 'Subscription'),
              link: '/plan-pricing/subscription',
              sublinks: [
                '/plan-pricing/subscription',
                '/plan-pricing/change-plan',
                '/plan-pricing/add-on-package',
              ],
            },
          ],
        },
      ],
    },
    {
      id: 9000,
      title: t('c.l.sidebar.9000.title', 'SYSTEM'),
      items: [
        {
          id: 9100,
          privileges:
            'P301_CX_ACCOUNT_MNGT,P302_CX_TEAM_SETTINGS,P106_DEVICE,P401_CRM_BA_MNGT,P403_CRM_STORE_MNGT',
          title: t('c.l.sidebar.9100.title', 'General Settings'),
          link: subscriptionUtils.isOwnerRole(accountSummary)
            ? '/general-settings/account-settings'
            : canManageStore(accountSummary)
            ? '/general-settings/location-management'
            : canManageLicense(accountSummary)
            ? '/general-settings/devices'
            : '/general-settings/team-settings',
          icon: 'la la-cog',
          sublinks: [
            '/general-settings/team-settings',
            '/general-settings/devices',
            '/general-settings/location-management',
            '/general-settings/location-management/sort-location',
          ],
          items: [
            {
              id: 9110,
              privileges: 'P301_CX_ACCOUNT_MNGT',
              title: t('c.l.sidebar.9110.title', 'Account'),
              link: '/general-settings/account-settings',
            },
            ...(functionType === 'SKINCARE_PRO' &&
            subscriptionUtils.isSkincareVersionAbove2(accountSummary) &&
            !isCnSite
              ? [
                  {
                    id: 9170,
                    privileges: 'P403_CRM_STORE_MNGT',
                    title: t('c.l.sidebar.9170.title', 'Location'),
                    link: '/general-settings/location-management',
                    sublinks: [
                      '/general-settings/location-management',
                      '/general-settings/location-management/sort-location',
                    ],
                  },
                ]
              : []),
            {
              id: 9130,
              privileges: 'P302_CX_TEAM_SETTINGS',
              title: t('c.l.sidebar.9130.title', 'Team'),
              link: '/general-settings/team-settings',
            },
            ...(functionType === 'SKINCARE_PRO'
              ? [
                  {
                    id: 9160,
                    privileges: 'P106_DEVICE',
                    title: t('c.l.sidebar.9160.title.v2', 'License'),
                    link: '/general-settings/devices',
                  },
                ]
              : []),
          ],
        },
      ],
    },
    functionType === 'SKINCARE_PRO' &&
      subscriptionUtils.isEnterprise(accountSummary) && {
        id: 11000,
        title: t('c.l.sidebar.11000.title', 'Server to Server API'),
        privileges: 'P501_SAAS_API',
        items: [
          {
            id: 11100,
            privileges: 'P501_SAAS_API',
            title: t('c.l.sidebar.11000.title', 'Server to Server API'),
            link: '/saas-api/api-integration',
            icon: 'la la-code',
            sublinks: ['/saas-api/api-integration'],
            items: [
              {
                id: 9110,
                privileges: 'P501_SAAS_API',
                title: t('c.l.sidebar.1150.title', 'API Integration'),
                link: '/saas-api/api-integration',
              },
            ],
          },
        ],
      },
    functionType === 'SKINCARE_PRO' &&
      privilegeUtils.isTechnicalSupport(accountSummary) && {
        id: 12000,
        title: t('c.l.sidebar.12000.title', 'All Customizations'),
        privileges: 'P601_CUSTOMIZATIONS',
        items: [
          {
            id: 12100,
            privileges: 'P601_CUSTOMIZATIONS',
            title: t('c.l.sidebar.12000.title', 'All Customizations'),
            link: '/customizations/customization-request',
            icon: 'fa fa-magic',
            sublinks: ['/customizations/customization-request'],
            items: [
              {
                id: 12110,
                privileges: 'P601_CUSTOMIZATIONS',
                title: t('c.l.sidebar.12110.title', 'Customization Request'),
                link: '/customizations/customization-request',
              },
            ],
          },
        ],
      },
  ];
};
